import { useState } from "react";
import { Plus } from "lucide-react";
import TaskForm from "./TaskForm";

/**
 * Standalone "+ Aggiungi ciclo" button that opens the shared TaskForm modal.
 * Used in the header of /cicli, /cicli/da-aprire, /cicli/aperti, /cicli/chiusi.
 *
 * Props:
 *   - onSaved  callback fired after successful task creation (parent may refetch)
 *   - prefillScheduledDate  optional ISO date to prefill (e.g. from /cicli/aperti context)
 *   - variant  "primary" (default) | "secondary" | "compact" | "compact-secondary"
 *   - label    override label text (default "Aggiungi ciclo")
 *   - testid   optional testid override
 */
export default function AddCicloButton({
  onSaved,
  prefillScheduledDate = null,
  prefillMetaId = null,
  variant = "primary",
  label = "Aggiungi ciclo",
  testid = "add-ciclo-btn",
}) {
  const [open, setOpen] = useState(false);

  const isCompact = variant.startsWith("compact");
  const isSecondary = variant.endsWith("secondary");
  const btnClass = [
    isCompact ? "text-xs px-3 py-1.5" : "",
    isSecondary ? "pxos-btn-secondary" : "pxos-btn-primary",
    "inline-flex items-center gap-1.5",
  ].join(" ").trim();

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={btnClass}
        data-testid={testid}
      >
        <Plus size={isCompact ? 14 : 16} />
        {label}
      </button>
      <TaskForm
        open={open}
        onClose={() => setOpen(false)}
        onSaved={() => { setOpen(false); onSaved?.(); }}
        prefillScheduledDate={prefillScheduledDate}
        prefillMetaId={prefillMetaId}
      />
    </>
  );
}
